/* Cuenta. Sólo tokens (tokens.css) y la escala de base.css: ningún color, tamaño de letra ni radio sueltos. */

/* ── Estructura ─────────────────────────────────────────────────────────── */
.columnas { display: flex; flex-wrap: wrap; gap: var(--e-6); align-items: flex-start; }
.principal { flex: 1 1 600px; min-width: 0; display: flex; flex-direction: column; gap: var(--e-5); }
.lateral { flex: 0 1 380px; min-width: 300px; display: flex; flex-direction: column; gap: var(--e-5); }
@media (max-width: 1023px) { .lateral { flex: 1 1 100%; } }
.pila { display: flex; flex-direction: column; gap: var(--e-4); min-width: 0; }
.estrecha { display: flex; flex-direction: column; gap: var(--e-5); max-width: 640px; }
.media { display: flex; flex-direction: column; gap: var(--e-4); max-width: 880px; }
.relleno { padding: var(--e-4); }
.rejilla { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(260px, 100%), 1fr)); gap: var(--e-4); }
.rejillaCorta { display: grid; grid-template-columns: repeat(auto-fill, minmax(min(260px, 100%), 1fr)); gap: var(--e-4); }
.ajustado { display: flex; }
.completa { grid-column: 1 / -1; }
.acciones { display: flex; flex-wrap: wrap; gap: var(--e-2); align-items: center; }
.accionesFin { display: flex; flex-wrap: wrap; gap: var(--e-2); align-items: center; justify-content: flex-end; }
.separador { height: 1px; background: var(--c-line-2); border: 0; margin: 0; }

/* ── Texto ──────────────────────────────────────────────────────────────── */
.nota { font: var(--t-nota); color: var(--c-ink-2); }
.tenue { color: var(--c-ink-2); }
.fuerte { font-weight: 600; }
.peligroTexto { color: var(--c-danger); }
.dato { display: flex; flex-direction: column; gap: var(--e-1); min-width: 0; }
.datoEtiqueta { font: var(--t-pequeno); color: var(--c-ink-2); }
.datoValor { display: flex; flex-wrap: wrap; align-items: center; gap: var(--e-2); overflow-wrap: anywhere; }
.lista { display: flex; flex-direction: column; gap: var(--e-1); padding-inline-start: var(--e-5); list-style: disc; color: var(--c-ink-2); }
.enlaceTexto { border: 0; padding: 0; background: none; color: var(--c-accent-ink); font: inherit; cursor: pointer; text-decoration: underline; }

/* ── Filas de enlace (la columna lateral) ───────────────────────────────── */
.filas { display: flex; flex-direction: column; margin: 0 calc(-1 * var(--e-2)); }
.fila {
  display: flex; align-items: center; gap: var(--e-3); padding: var(--e-2); border-radius: var(--r-sm);
  color: var(--c-ink); text-decoration: none; background: none; border: 0; font: inherit; text-align: left; cursor: pointer; width: 100%;
}
.fila:hover { background: var(--c-surface-2); text-decoration: none; }
.fila:focus-visible { outline: 2px solid var(--c-accent-fill); outline-offset: 0; }
.filaFija { display: flex; align-items: center; gap: var(--e-3); padding: var(--e-2); }
.filaIcono { flex: none; width: 32px; height: 32px; border-radius: var(--r-sm); display: grid; place-items: center; background: var(--c-surface-2); color: var(--c-ink-2); }
.fila[data-tono='peligro'] { color: var(--c-danger); }
.fila[data-tono='peligro'] .filaIcono { background: var(--c-danger-soft); color: var(--c-danger); }
.fila[data-tono='aviso'] .filaIcono { background: var(--c-warn-soft); color: var(--c-warn); }
.filaTextos { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1; }
.filaTitulo { font-weight: 600; }
.filaSub { font: var(--t-nota); color: var(--c-ink-2); }
.filaValor { font: var(--t-nota); color: var(--c-ink-2); white-space: nowrap; }

/* ── Saldo de créditos ──────────────────────────────────────────────────── */
.saldo { display: flex; flex-direction: column; gap: var(--e-2); }
.saldoCabeza { display: flex; align-items: baseline; justify-content: space-between; gap: var(--e-3); flex-wrap: wrap; }
.saldoTitulo { font: var(--t-seccion); }
.saldoCifra { font: var(--t-titulo); font-variant-numeric: tabular-nums; }
.saldoCifra[data-tono='aviso'] { color: var(--c-warn); }
.saldoCifra[data-tono='agotada'] { color: var(--c-danger); }
.saldoTexto[data-tono='agotada'] { color: var(--c-danger); }

/* ── Planes ─────────────────────────────────────────────────────────────── */
.planes { display: grid; grid-template-columns: repeat(auto-fit, minmax(min(240px, 100%), 1fr)); gap: var(--e-4); }
.plan { display: flex; flex-direction: column; gap: var(--e-2); padding: var(--e-5); border: 1px solid var(--borde-suave); border-radius: var(--r-lg); background: var(--c-surface); }
.plan[data-actual] { border-color: var(--c-accent-fill); box-shadow: inset 0 0 0 1px var(--c-accent-fill); }
.planCabeza { display: flex; align-items: center; justify-content: space-between; gap: var(--e-2); }
.planNombre { font: var(--t-titulo); }
.planCreditos { font: var(--t-seccion); font-variant-numeric: tabular-nums; }
.planPrecio { margin-top: auto; padding-top: var(--e-2); color: var(--c-ink-2); font: var(--t-pequeno); }
.planPrecio strong { color: var(--c-ink); font: 600 20px/1.2 var(--f-ui); font-variant-numeric: tabular-nums; }
.plan > button { align-self: flex-start; }
.comparativa { width: 100%; border-collapse: collapse; font-variant-numeric: tabular-nums; }
.comparativa th, .comparativa td { text-align: left; padding: var(--e-2) var(--e-3); border-bottom: 1px solid var(--c-line-2); }
.comparativa th { font: var(--t-pequeno); color: var(--c-ink-2); font-weight: 600; }
.comparativa tr[data-actual] td { font-weight: 600; }
.cajaTabla { overflow-x: auto; }
.pasos { display: flex; flex-direction: column; gap: var(--e-2); padding-inline-start: var(--e-5); list-style: decimal; }

/* ── Notificaciones ─────────────────────────────────────────────────────── */
.avisos { display: flex; flex-direction: column; }
.avisoFila {
  display: flex; gap: var(--e-3); align-items: flex-start; padding: var(--e-3) var(--e-5); border: 0; border-top: 1px solid var(--c-line-2);
  background: none; font: inherit; color: inherit; text-align: left; width: 100%; cursor: pointer;
}
.avisos > .avisoFila:first-child { border-top: 0; }
.avisoFila:hover { background: var(--c-surface-2); }
.avisoFila:focus-visible { outline: 2px solid var(--c-accent-fill); outline-offset: -2px; }
.avisoFila[data-sin-leer] { background: var(--c-surface-2); }
.avisoIcono { flex: none; margin-top: 2px; color: var(--c-warn); }
.avisoIcono[data-tipo='vencido'] { color: var(--c-danger); }
.avisoTextos { display: flex; flex-direction: column; gap: var(--e-1); min-width: 0; flex: 1; }
.avisoMensaje { overflow-wrap: anywhere; }
.avisoFila[data-sin-leer] .avisoMensaje { font-weight: 600; }
.avisoMeta { display: flex; flex-wrap: wrap; align-items: center; column-gap: var(--e-3); row-gap: 2px; font: var(--t-nota); color: var(--c-ink-2); }
.punto { flex: none; width: 8px; height: 8px; border-radius: var(--r-full); background: var(--c-action); margin-top: var(--e-2); }

/* ── La campana (cabecera del marco) ────────────────────────────────────── */
.campana {
  position: relative; width: 40px; height: 40px; border-radius: var(--r-sm); border: 1px solid var(--borde-suave);
  background: var(--c-surface); color: var(--c-ink); display: grid; place-items: center; cursor: pointer;
}
.campana[data-hovered] { background: var(--c-surface-2); }
.campana[data-focus-visible] { outline: 2px solid var(--c-accent-fill); outline-offset: 2px; }
.contador {
  position: absolute; top: -6px; right: -6px; min-width: 20px; height: 20px; padding: 0 5px; border-radius: var(--r-full);
  background: var(--c-danger); color: var(--c-on-action); font: var(--t-nota); font-weight: 600; line-height: 20px; text-align: center; font-variant-numeric: tabular-nums;
}
.popover { width: min(420px, calc(100vw - 32px)); background: var(--c-surface); border: 1px solid var(--borde-suave); border-radius: var(--r-md); box-shadow: 0 12px 32px color-mix(in srgb, var(--c-sombra) 14%, transparent); display: flex; flex-direction: column; max-height: min(560px, calc(100vh - 96px)); outline: none; }
.popoverDialogo { display: flex; flex-direction: column; min-height: 0; max-height: inherit; outline: none; }
.popoverNota { font: var(--t-nota); color: var(--c-ink-2); padding: var(--e-4); }
.popoverCabeza { display: flex; align-items: center; justify-content: space-between; gap: var(--e-3); padding: var(--e-3) var(--e-4) var(--e-2) var(--e-5); border-bottom: 1px solid var(--c-line-2); }
.popoverTitulo { font: var(--t-seccion); }
.popoverCuerpo { overflow: auto; flex: 1; }
.popoverPie { padding: var(--e-2) var(--e-4); border-top: 1px solid var(--c-line-2); display: flex; justify-content: flex-end; }
.popover .avisoFila { padding: var(--e-3) var(--e-4); }

/* ── Tribunales ─────────────────────────────────────────────────────────── */
.grupoTribunales { border-top: 1px solid var(--c-line-2); }
.grupoTribunales:first-child { border-top: 0; }
.grupoBoton { display: flex; align-items: center; justify-content: space-between; gap: var(--e-3); width: 100%; padding: var(--e-3) var(--e-5); background: none; border: 0; font: inherit; color: inherit; cursor: pointer; text-align: left; }
.grupoBoton:hover { background: var(--c-surface-2); }
.grupoBoton:focus-visible { outline: 2px solid var(--c-accent-fill); outline-offset: -2px; }
.tribunales { display: flex; flex-direction: column; padding: 0 var(--e-5) var(--e-3) calc(var(--e-5) + var(--e-6)); gap: var(--e-1); }
.tribunal { display: flex; align-items: center; gap: var(--e-2); flex-wrap: wrap; }

/* ── Borrar datos ───────────────────────────────────────────────────────── */
.ambitos { display: flex; flex-direction: column; gap: var(--e-4); }
.ambitoTextos { display: flex; flex-direction: column; gap: 2px; }
.ambitoAviso { font: var(--t-nota); color: var(--c-warn); }
.ambitoCuenta { font: var(--t-nota); font-weight: 600; color: var(--c-ink-2); }

/* ── Final (cuenta eliminada) ───────────────────────────────────────────── */
.final { min-height: 100%; display: grid; place-items: center; padding: var(--e-10) var(--e-4); background: var(--c-bg); }
.finalCaja { max-width: 480px; display: flex; flex-direction: column; align-items: center; gap: var(--e-4); text-align: center; }
.finalIcono { color: var(--c-ok); }
.finalTitulo { font: var(--t-display); }

/* ── Documentos legales ─────────────────────────────────────────────────── */
.docColumnas { display: flex; gap: var(--e-8); align-items: flex-start; }
.docIndice { flex: 0 0 280px; position: sticky; top: var(--e-4); max-height: calc(100vh - 120px); overflow: auto; display: flex; flex-direction: column; gap: var(--e-2); padding-inline-end: var(--e-2); }
.docIndiceTitulo { font: var(--t-seccion); }
.docIndice ol { display: flex; flex-direction: column; gap: var(--e-1); }
.docIndice a { display: block; font: var(--t-pequeno); color: var(--c-ink-2); text-decoration: none; padding: 2px 0; }
.docIndice a:hover { color: var(--c-accent-ink); }
@media (max-width: 1023px) { .docColumnas { flex-direction: column; } .docIndice { position: static; flex: none; max-height: none; width: 100%; } }
.docTexto { flex: 1; min-width: 0; max-width: var(--ancho-lectura); display: flex; flex-direction: column; gap: var(--e-3); font: var(--t-lectura); color: var(--c-ink); }
.docTexto code { font-family: ui-monospace, monospace; background: var(--c-fill); padding: 0 var(--e-1); border-radius: var(--r-sm); }
.docH2 { font: var(--t-titulo); margin-top: var(--e-6); scroll-margin-top: var(--e-4); }
.docH3 { font: var(--t-lectura); font-weight: 600; margin-top: var(--e-3); scroll-margin-top: var(--e-4); }
.docP { white-space: pre-line; }
.docNota { padding: var(--e-3) var(--e-4); border-radius: var(--r-md); background: var(--c-warn-soft); }
.docNota[data-tipo='cita'] { background: var(--c-surface-2); }
.docLi { display: flex; gap: var(--e-2); }
.docVineta { flex: none; min-width: 1.4em; color: var(--c-ink-3); }
.docHr { border: 0; height: 1px; background: var(--c-line-2); margin: var(--e-2) 0; }
.docTablaCaja { overflow-x: auto; }
.docTabla { border-collapse: collapse; font: var(--t-pequeno); width: 100%; }
.docTabla th, .docTabla td { border: 1px solid var(--c-line-2); padding: var(--e-2) var(--e-3); text-align: left; vertical-align: top; }
.docTabla th { background: var(--c-surface-2); }
